/**
 * GENERATED by scripts/gen_analytics_events.py from schemas/analytics/ — do not edit.
 *
 * Property types, enum unions and trust tiers for every client analytics event.
 * Call sites emit through the typed helpers in `analytics/events.ts`.
 */

// ─── Enums ──────────────────────────────────────────────────────────────────

export type ActionResult = 'success' | 'failure'
export const ACTION_RESULT_VALUES: readonly ActionResult[] = ['success', 'failure']

export type AllowanceAction = 'edit_opened' | 'set' | 'clear'
export const ALLOWANCE_ACTION_VALUES: readonly AllowanceAction[] = ['edit_opened', 'set', 'clear']

export type AllowanceLimitType = 'no_limit' | 'fixed' | 'recurring'
export const ALLOWANCE_LIMIT_TYPE_VALUES: readonly AllowanceLimitType[] = ['no_limit', 'fixed', 'recurring']

export type AllowancePeriod = 'daily' | 'weekly' | 'monthly'
export const ALLOWANCE_PERIOD_VALUES: readonly AllowancePeriod[] = ['daily', 'weekly', 'monthly']

export type ApiKeyAction = 'create' | 'revoke'
export const API_KEY_ACTION_VALUES: readonly ApiKeyAction[] = ['create', 'revoke']

export type AppArea = 'workspace' | 'dashboard' | 'landing' | 'other'
export const APP_AREA_VALUES: readonly AppArea[] = ['workspace', 'dashboard', 'landing', 'other']

export type AssetDownloadAction = 'initiated' | 'failed'
export const ASSET_DOWNLOAD_ACTION_VALUES: readonly AssetDownloadAction[] = ['initiated', 'failed']

export type AssetDownloadEntryPoint = 'node_toolbar' | 'variant_card' | 'canvas_bottom_bar' | 'list_view' | 'project_export' | 'other'
export const ASSET_DOWNLOAD_ENTRY_POINT_VALUES: readonly AssetDownloadEntryPoint[] = ['node_toolbar', 'variant_card', 'canvas_bottom_bar', 'list_view', 'project_export', 'other']

export type AssetDownloadErrorCategory = 'missing_asset' | 'url_build_failed' | 'http_error' | 'network_error' | 'handoff_failed' | 'unknown'
export const ASSET_DOWNLOAD_ERROR_CATEGORY_VALUES: readonly AssetDownloadErrorCategory[] = ['missing_asset', 'url_build_failed', 'http_error', 'network_error', 'handoff_failed', 'unknown']

export type AssetDownloadTarget = 'node_output' | 'variant' | 'project'
export const ASSET_DOWNLOAD_TARGET_VALUES: readonly AssetDownloadTarget[] = ['node_output', 'variant', 'project']

export type AssetKind = 'image' | 'video'
export const ASSET_KIND_VALUES: readonly AssetKind[] = ['image', 'video']

export type AssetTrigger = 'canvas_hydration' | 'post_generation'
export const ASSET_TRIGGER_VALUES: readonly AssetTrigger[] = ['canvas_hydration', 'post_generation']

export type AttachmentType = 'image' | 'video' | 'audio' | 'document'
export const ATTACHMENT_TYPE_VALUES: readonly AttachmentType[] = ['image', 'video', 'audio', 'document']

export type AuthMethod = 'google' | 'email' | 'facebook'
export const AUTH_METHOD_VALUES: readonly AuthMethod[] = ['google', 'email', 'facebook']

export type AutoPromptReason = 'batch_complete' | 'cross_canvas_message'
export const AUTO_PROMPT_REASON_VALUES: readonly AutoPromptReason[] = ['batch_complete', 'cross_canvas_message']

export type BlockedAction = 'video_generate' | 'image_generate' | 'audio_generate' | 'text_generate' | 'storyboard_generate' | 'other'
export const BLOCKED_ACTION_VALUES: readonly BlockedAction[] = ['video_generate', 'image_generate', 'audio_generate', 'text_generate', 'storyboard_generate', 'other']

export type ByomAction = 'add_started' | 'test_result' | 'save_result' | 'test_clicked' | 'save_clicked' | 'delete_clicked'
export const BYOM_ACTION_VALUES: readonly ByomAction[] = ['add_started', 'test_result', 'save_result', 'test_clicked', 'save_clicked', 'delete_clicked']

export type ByomEntryPoint = 'settings' | 'project_settings'
export const BYOM_ENTRY_POINT_VALUES: readonly ByomEntryPoint[] = ['settings', 'project_settings']

export type ByomModelType = 'video' | 'director' | 'image'
export const BYOM_MODEL_TYPE_VALUES: readonly ByomModelType[] = ['video', 'director', 'image']

export type ByomProvider = 'anthropic_messages' | 'openai_chat_completions' | 'custom' | 'byteplus_seedance_2'
export const BYOM_PROVIDER_VALUES: readonly ByomProvider[] = ['anthropic_messages', 'openai_chat_completions', 'custom', 'byteplus_seedance_2']

export type CatalogSource = 'placeholder' | 'live'
export const CATALOG_SOURCE_VALUES: readonly CatalogSource[] = ['placeholder', 'live']

export type ChatCardAction = 'select' | 'custom_submit' | 'skip' | 'submit' | 'confirm' | 'dismiss' | 'create' | 'finished' | 'apply'
export const CHAT_CARD_ACTION_VALUES: readonly ChatCardAction[] = ['select', 'custom_submit', 'skip', 'submit', 'confirm', 'dismiss', 'create', 'finished', 'apply']

export type ChatCardType = 'question' | 'batched_question' | 'library_picker' | 'create_project' | 'project_setup' | 'global_config' | 'voice_catalogue' | 'style_choice'
export const CHAT_CARD_TYPE_VALUES: readonly ChatCardType[] = ['question', 'batched_question', 'library_picker', 'create_project', 'project_setup', 'global_config', 'voice_catalogue', 'style_choice']

export type ContextMenuAction = 'upload' | 'asset_manager' | 'add_nodes' | 'undo' | 'redo' | 'paste' | 'add_to_chat' | 'save_to_library' | 'download' | 'copy' | 'duplicate' | 'project_settings' | 'delete' | 'send_feedback'
export const CONTEXT_MENU_ACTION_VALUES: readonly ContextMenuAction[] = ['upload', 'asset_manager', 'add_nodes', 'undo', 'redo', 'paste', 'add_to_chat', 'save_to_library', 'download', 'copy', 'duplicate', 'project_settings', 'delete', 'send_feedback']

export type ContextMenuKind = 'node' | 'canvas'
export const CONTEXT_MENU_KIND_VALUES: readonly ContextMenuKind[] = ['node', 'canvas']

export type CountBucket = '0' | '1' | '2-3' | '4-5' | '6-10' | '11-20' | '21-50' | '51+'
export const COUNT_BUCKET_VALUES: readonly CountBucket[] = ['0', '1', '2-3', '4-5', '6-10', '11-20', '21-50', '51+']

export type CreditsBlockReason = 'allowance_cap' | 'insufficient_balance' | 'unknown'
export const CREDITS_BLOCK_REASON_VALUES: readonly CreditsBlockReason[] = ['allowance_cap', 'insufficient_balance', 'unknown']

export type CreditsBucket = '0' | '1-100' | '101-500' | '501-1000' | '1001-5000' | '5001+'
export const CREDITS_BUCKET_VALUES: readonly CreditsBucket[] = ['0', '1-100', '101-500', '501-1000', '1001-5000', '5001+']

export type CreditsEntryPoint = 'user_menu' | 'settings_deeplink' | 'low_balance_prompt' | 'dashboard_banner'
export const CREDITS_ENTRY_POINT_VALUES: readonly CreditsEntryPoint[] = ['user_menu', 'settings_deeplink', 'low_balance_prompt', 'dashboard_banner']

export type DownloadKind = 'single' | 'bulk'
export const DOWNLOAD_KIND_VALUES: readonly DownloadKind[] = ['single', 'bulk']

export type EdgeAction = 'connect'
export const EDGE_ACTION_VALUES: readonly EdgeAction[] = ['connect']

export type EditorEntryPoint = 'node_preview_button' | 'node_actions_button' | 'node_toolbar'
export const EDITOR_ENTRY_POINT_VALUES: readonly EditorEntryPoint[] = ['node_preview_button', 'node_actions_button', 'node_toolbar']

export type ErrorKind = 'error' | 'unhandledrejection'
export const ERROR_KIND_VALUES: readonly ErrorKind[] = ['error', 'unhandledrejection']

export type ExecuteNodeAction = 'generate' | 'rewrite_with_model' | 'replace_from_script' | 'resync_from_script' | 'generate_shot_list' | 'generate_shot_frames_key' | 'generate_shot_frames_start_end' | 'generate_shot_frames_all' | 'extract_depth' | 'upscale' | 'timeline_render' | 'vibe_render' | 'run_speech_to_text' | 'reformat_motion_prompt' | 'run_audio_split'
export const EXECUTE_NODE_ACTION_VALUES: readonly ExecuteNodeAction[] = ['generate', 'rewrite_with_model', 'replace_from_script', 'resync_from_script', 'generate_shot_list', 'generate_shot_frames_key', 'generate_shot_frames_start_end', 'generate_shot_frames_all', 'extract_depth', 'upscale', 'timeline_render', 'vibe_render', 'run_speech_to_text', 'reformat_motion_prompt', 'run_audio_split']

export type ExecutionPlanAction = 'confirm' | 'cancel'
export const EXECUTION_PLAN_ACTION_VALUES: readonly ExecutionPlanAction[] = ['confirm', 'cancel']

export type FeedbackCategory = 'bug' | 'feature' | 'question'
export const FEEDBACK_CATEGORY_VALUES: readonly FeedbackCategory[] = ['bug', 'feature', 'question']

export type GenerationCancelStage = 'grace' | 'running'
export const GENERATION_CANCEL_STAGE_VALUES: readonly GenerationCancelStage[] = ['grace', 'running']

export type GenerationMode = 'initial' | 'retry' | 'refine'
export const GENERATION_MODE_VALUES: readonly GenerationMode[] = ['initial', 'retry', 'refine']

export type HeaderControl = 'director_desk' | 'version_history' | 'project_rules' | 'settings' | 'publish' | 'feedback' | 'credits' | 'rename'
export const HEADER_CONTROL_VALUES: readonly HeaderControl[] = ['director_desk', 'version_history', 'project_rules', 'settings', 'publish', 'feedback', 'credits', 'rename']

export type HeaderEntryPoint = 'project_header'
export const HEADER_ENTRY_POINT_VALUES: readonly HeaderEntryPoint[] = ['project_header']

export type HeaderSurface = 'director_desk_3d' | 'version_history' | 'project_settings' | 'publish'
export const HEADER_SURFACE_VALUES: readonly HeaderSurface[] = ['director_desk_3d', 'version_history', 'project_settings', 'publish']

export type HeaderSurfaceEntryPoint = 'header_click' | 'deeplink' | 'chat_card' | 'other'
export const HEADER_SURFACE_ENTRY_POINT_VALUES: readonly HeaderSurfaceEntryPoint[] = ['header_click', 'deeplink', 'chat_card', 'other']

export type InsufficientCreditsModalAction = 'close'
export const INSUFFICIENT_CREDITS_MODAL_ACTION_VALUES: readonly InsufficientCreditsModalAction[] = ['close']

export type InteractionArea = 'canvas' | 'chat' | 'timeline' | 'other'
export const INTERACTION_AREA_VALUES: readonly InteractionArea[] = ['canvas', 'chat', 'timeline', 'other']

export type InviteExpiryBucket = '1d' | '7d' | '30d'
export const INVITE_EXPIRY_BUCKET_VALUES: readonly InviteExpiryBucket[] = ['1d', '7d', '30d']

export type InviteRole = 'admin' | 'member'
export const INVITE_ROLE_VALUES: readonly InviteRole[] = ['admin', 'member']

export type LandingPromptOptionAction = 'open' | 'change' | 'reset'
export const LANDING_PROMPT_OPTION_ACTION_VALUES: readonly LandingPromptOptionAction[] = ['open', 'change', 'reset']

export type LandingPromptOptionType = 'style' | 'project_setup'
export const LANDING_PROMPT_OPTION_TYPE_VALUES: readonly LandingPromptOptionType[] = ['style', 'project_setup']

export type LandingStoryOpenTrigger = 'card_click' | 'fullscreen_button'
export const LANDING_STORY_OPEN_TRIGGER_VALUES: readonly LandingStoryOpenTrigger[] = ['card_click', 'fullscreen_button']

export type LandingStoryPreviewTrigger = 'hover'
export const LANDING_STORY_PREVIEW_TRIGGER_VALUES: readonly LandingStoryPreviewTrigger[] = ['hover']

export type LandingStyleFamily = 'live_action_cinema' | '3d_animation' | '2d_animation' | 'stop_motion' | 'illustration' | 'other' | 'custom' | 'none'
export const LANDING_STYLE_FAMILY_VALUES: readonly LandingStyleFamily[] = ['live_action_cinema', '3d_animation', '2d_animation', 'stop_motion', 'illustration', 'other', 'custom', 'none']

export type LatencyBucket = 'lt_1s' | '1-3s' | '3-10s' | '10-30s' | '30-60s' | 'gt_60s'
export const LATENCY_BUCKET_VALUES: readonly LatencyBucket[] = ['lt_1s', '1-3s', '3-10s', '10-30s', '30-60s', 'gt_60s']

export type LengthBucket = '0' | '1-20' | '21-50' | '51-100' | '101-250' | '251-500' | '501-1000' | '1001+'
export const LENGTH_BUCKET_VALUES: readonly LengthBucket[] = ['0', '1-20', '21-50', '51-100', '101-250', '251-500', '501-1000', '1001+']

export type LoadOutcome = 'ready' | 'error' | 'timeout'
export const LOAD_OUTCOME_VALUES: readonly LoadOutcome[] = ['ready', 'error', 'timeout']

export type ModelSource = 'native' | 'byom'
export const MODEL_SOURCE_VALUES: readonly ModelSource[] = ['native', 'byom']

export type NodeMutationAction = 'add' | 'duplicate' | 'change_type' | 'delete'
export const NODE_MUTATION_ACTION_VALUES: readonly NodeMutationAction[] = ['add', 'duplicate', 'change_type', 'delete']

export type NodeMutationSource = 'add_menu' | 'asset_library' | 'file_upload' | 'drop' | 'paste' | 'node_toolbar' | 'keyboard' | 'context_menu'
export const NODE_MUTATION_SOURCE_VALUES: readonly NodeMutationSource[] = ['add_menu', 'asset_library', 'file_upload', 'drop', 'paste', 'node_toolbar', 'keyboard', 'context_menu']

export type NodePanelTab = 'config' | 'refine' | 'variants' | 'voice' | 'quality'
export const NODE_PANEL_TAB_VALUES: readonly NodePanelTab[] = ['config', 'refine', 'variants', 'voice', 'quality']

export type NodeToolbarControl = 'add_to_chat' | 'save_to_library' | 'extract_frame' | 'extract_audio' | 'depth' | 'ai_clips' | 'upscale' | 'panorama' | 'location_angles' | 'fullscreen' | 'annotate'
export const NODE_TOOLBAR_CONTROL_VALUES: readonly NodeToolbarControl[] = ['add_to_chat', 'save_to_library', 'extract_frame', 'extract_audio', 'depth', 'ai_clips', 'upscale', 'panorama', 'location_angles', 'fullscreen', 'annotate']

export type NuxDismissSource = 'skipped' | 'completed'
export const NUX_DISMISS_SOURCE_VALUES: readonly NuxDismissSource[] = ['skipped', 'completed']

export type OnboardingIntakeMode = 'single' | 'bulk'
export const ONBOARDING_INTAKE_MODE_VALUES: readonly OnboardingIntakeMode[] = ['single', 'bulk']

export type OutputMediaType = 'image' | 'video' | 'audio'
export const OUTPUT_MEDIA_TYPE_VALUES: readonly OutputMediaType[] = ['image', 'video', 'audio']

export type OutputViewEntryPoint = 'canvas_node' | 'variants_tab' | 'list_view' | 'list_detail'
export const OUTPUT_VIEW_ENTRY_POINT_VALUES: readonly OutputViewEntryPoint[] = ['canvas_node', 'variants_tab', 'list_view', 'list_detail']

export type OutputViewType = 'image_visible' | 'video_play_started' | 'audio_play_started'
export const OUTPUT_VIEW_TYPE_VALUES: readonly OutputViewType[] = ['image_visible', 'video_play_started', 'audio_play_started']

export type OwnerType = 'personal' | 'team'
export const OWNER_TYPE_VALUES: readonly OwnerType[] = ['personal', 'team']

export type PageVisibilityState = 'visible' | 'hidden'
export const PAGE_VISIBILITY_STATE_VALUES: readonly PageVisibilityState[] = ['visible', 'hidden']

export type PaletteAction = 'open' | 'close' | 'pick' | 'search' | 'file_selected' | 'file_cancelled' | 'tab' | 'select' | 'deselect' | 'select_all' | 'deselect_all' | 'add_to_canvas' | 'delete' | 'delete_confirmed' | 'delete_cancelled' | 'download'
export const PALETTE_ACTION_VALUES: readonly PaletteAction[] = ['open', 'close', 'pick', 'search', 'file_selected', 'file_cancelled', 'tab', 'select', 'deselect', 'select_all', 'deselect_all', 'add_to_canvas', 'delete', 'delete_confirmed', 'delete_cancelled', 'download']

export type PaletteControl = 'add_node' | 'tool' | 'asset_library' | 'download' | 'shortcuts' | 'view_switch' | 'category'
export const PALETTE_CONTROL_VALUES: readonly PaletteControl[] = ['add_node', 'tool', 'asset_library', 'download', 'shortcuts', 'view_switch', 'category']

export type PaletteSurface = 'canvas_palette' | 'list_palette' | 'list_rail'
export const PALETTE_SURFACE_VALUES: readonly PaletteSurface[] = ['canvas_palette', 'list_palette', 'list_rail']

export type PaymentContainerModeEvent = 'TEST' | 'LIVE'
export const PAYMENT_CONTAINER_MODE_EVENT_VALUES: readonly PaymentContainerModeEvent[] = ['TEST', 'LIVE']

export type PlaybackTrigger = 'manual' | 'autoplay'
export const PLAYBACK_TRIGGER_VALUES: readonly PlaybackTrigger[] = ['manual', 'autoplay']

export type PresenceAction = 'enter' | 'visibility_change' | 'heartbeat' | 'exit'
export const PRESENCE_ACTION_VALUES: readonly PresenceAction[] = ['enter', 'visibility_change', 'heartbeat', 'exit']

export type ProfileSettingKey = 'display_name' | 'ui_locale'
export const PROFILE_SETTING_KEY_VALUES: readonly ProfileSettingKey[] = ['display_name', 'ui_locale']

export type ProfileVideoModelSource = 'auto' | 'native' | 'byom'
export const PROFILE_VIDEO_MODEL_SOURCE_VALUES: readonly ProfileVideoModelSource[] = ['auto', 'native', 'byom']

export type ProjectCreateEntryPoint = 'dashboard_header' | 'empty_tab' | 'first_project'
export const PROJECT_CREATE_ENTRY_POINT_VALUES: readonly ProjectCreateEntryPoint[] = ['dashboard_header', 'empty_tab', 'first_project']

export type ProjectCreationSource = 'landing_prompt' | 'project_page_new' | 'clone' | 'template' | 'import'
export const PROJECT_CREATION_SOURCE_VALUES: readonly ProjectCreationSource[] = ['landing_prompt', 'project_page_new', 'clone', 'template', 'import']

export type ProjectSettingKey = 'auto_confirm_image_costs' | 'auto_confirm_video_costs' | 'task_completion_chime' | 'always_hide_edges' | 'hide_edges_during_interaction' | 'image_preview_only_during_interaction' | 'lightweight_image_node_shell' | 'lightweight_node_chrome' | 'preview_preserving_interaction_lod' | 'render_active_edges_only' | 'render_only_visible_elements' | 'snap_to_grid' | 'viewport_preview_layer' | 'remove_watermark' | 'style' | 'aspect_ratio' | 'content_language' | 'video_resolution' | 'preferred_video_models' | 'preferred_image_model'
export const PROJECT_SETTING_KEY_VALUES: readonly ProjectSettingKey[] = ['auto_confirm_image_costs', 'auto_confirm_video_costs', 'task_completion_chime', 'always_hide_edges', 'hide_edges_during_interaction', 'image_preview_only_during_interaction', 'lightweight_image_node_shell', 'lightweight_node_chrome', 'preview_preserving_interaction_lod', 'render_active_edges_only', 'render_only_visible_elements', 'snap_to_grid', 'viewport_preview_layer', 'remove_watermark', 'style', 'aspect_ratio', 'content_language', 'video_resolution', 'preferred_video_models', 'preferred_image_model']

export type PromptSource = 'composer' | 'auto'
export const PROMPT_SOURCE_VALUES: readonly PromptSource[] = ['composer', 'auto']

export type PublishAction = 'publish' | 'new_version' | 'copy_link' | 'unpublish'
export const PUBLISH_ACTION_VALUES: readonly PublishAction[] = ['publish', 'new_version', 'copy_link', 'unpublish']

export type PublishErrorCategory = 'network' | 'unauthorized' | 'forbidden' | 'not_found' | 'conflict' | 'rate_limited' | 'client_error' | 'server_error' | 'unknown'
export const PUBLISH_ERROR_CATEGORY_VALUES: readonly PublishErrorCategory[] = ['network', 'unauthorized', 'forbidden', 'not_found', 'conflict', 'rate_limited', 'client_error', 'server_error', 'unknown']

export type QueuedPromptAction = 'send' | 'edit' | 'remove'
export const QUEUED_PROMPT_ACTION_VALUES: readonly QueuedPromptAction[] = ['send', 'edit', 'remove']

export type RedirectBlockReason = 'csp_form_action' | 'handoff_expired' | 'network' | 'navigation_cancelled'
export const REDIRECT_BLOCK_REASON_VALUES: readonly RedirectBlockReason[] = ['csp_form_action', 'handoff_expired', 'network', 'navigation_cancelled']

export type RefineControlAction = 'open_model' | 'select_model' | 'open_style'
export const REFINE_CONTROL_ACTION_VALUES: readonly RefineControlAction[] = ['open_model', 'select_model', 'open_style']

export type ReturnUnmatchedReason = 'unknown_order' | 'foreign_order' | 'expired'
export const RETURN_UNMATCHED_REASON_VALUES: readonly ReturnUnmatchedReason[] = ['unknown_order', 'foreign_order', 'expired']

export type RulesAction = 'save' | 'revert' | 'insert_example' | 'discard'
export const RULES_ACTION_VALUES: readonly RulesAction[] = ['save', 'revert', 'insert_example', 'discard']

export type RulesActor = 'user' | 'director' | 'director_proposal'
export const RULES_ACTOR_VALUES: readonly RulesActor[] = ['user', 'director', 'director_proposal']

export type RulesEntryPoint = 'user_menu' | 'settings_deeplink' | 'settings_nav' | 'canvas_toolbar' | 'project_header'
export const RULES_ENTRY_POINT_VALUES: readonly RulesEntryPoint[] = ['user_menu', 'settings_deeplink', 'settings_nav', 'canvas_toolbar', 'project_header']

export type RulesScope = 'user' | 'project'
export const RULES_SCOPE_VALUES: readonly RulesScope[] = ['user', 'project']

export type ServerResultErrorCategory = 'validation' | 'unauthorized' | 'forbidden' | 'not_found' | 'conflict' | 'rate_limited' | 'quota_exceeded' | 'too_large' | 'unsupported_type' | 'provider_error' | 'timeout' | 'storage_error' | 'server_error' | 'unknown'
export const SERVER_RESULT_ERROR_CATEGORY_VALUES: readonly ServerResultErrorCategory[] = ['validation', 'unauthorized', 'forbidden', 'not_found', 'conflict', 'rate_limited', 'quota_exceeded', 'too_large', 'unsupported_type', 'provider_error', 'timeout', 'storage_error', 'server_error', 'unknown']

export type SettingValueCategory = 'on' | 'off' | 'auto' | 'explicit' | '16:9' | '9:16' | '720p' | '1080p' | '4k' | 'unset'
export const SETTING_VALUE_CATEGORY_VALUES: readonly SettingValueCategory[] = ['on', 'off', 'auto', 'explicit', '16:9', '9:16', '720p', '1080p', '4k', 'unset']

export type SettingsViewEntryPoint = 'user_menu' | 'settings_deeplink' | 'settings_nav' | 'profile_flyout'
export const SETTINGS_VIEW_ENTRY_POINT_VALUES: readonly SettingsViewEntryPoint[] = ['user_menu', 'settings_deeplink', 'settings_nav', 'profile_flyout']

export type ShotListEditAction = 'cell_commit' | 'frame_relink' | 'undo' | 'redo'
export const SHOT_LIST_EDIT_ACTION_VALUES: readonly ShotListEditAction[] = ['cell_commit', 'frame_relink', 'undo', 'redo']

export type ShotListEditRole = 'start' | 'key' | 'end'
export const SHOT_LIST_EDIT_ROLE_VALUES: readonly ShotListEditRole[] = ['start', 'key', 'end']

export type ShotListEditSource = 'guided' | 'screenplay' | 'video' | 'flat'
export const SHOT_LIST_EDIT_SOURCE_VALUES: readonly ShotListEditSource[] = ['guided', 'screenplay', 'video', 'flat']

export type SigninEntryPoint = 'navbar'
export const SIGNIN_ENTRY_POINT_VALUES: readonly SigninEntryPoint[] = ['navbar']

export type SigninFailureReason = 'invalid_credentials' | 'email_not_confirmed' | 'rate_limited'
export const SIGNIN_FAILURE_REASON_VALUES: readonly SigninFailureReason[] = ['invalid_credentials', 'email_not_confirmed', 'rate_limited']

export type SkillCreationMode = 'upload' | 'director'
export const SKILL_CREATION_MODE_VALUES: readonly SkillCreationMode[] = ['upload', 'director']

export type SkillLibraryAction = 'install' | 'update' | 'uninstall' | 'publish' | 'delete' | 'save_version'
export const SKILL_LIBRARY_ACTION_VALUES: readonly SkillLibraryAction[] = ['install', 'update', 'uninstall', 'publish', 'delete', 'save_version']

export type SkillLoadReason = 'explicit_selection' | 'intent_match' | 'skill_composition'
export const SKILL_LOAD_REASON_VALUES: readonly SkillLoadReason[] = ['explicit_selection', 'intent_match', 'skill_composition']

export type SkillPickerAction = 'open' | 'tab_view' | 'select' | 'clear' | 'detail_view'
export const SKILL_PICKER_ACTION_VALUES: readonly SkillPickerAction[] = ['open', 'tab_view', 'select', 'clear', 'detail_view']

export type SkillPickerEntryPoint = 'composer_button' | 'slash_command'
export const SKILL_PICKER_ENTRY_POINT_VALUES: readonly SkillPickerEntryPoint[] = ['composer_button', 'slash_command']

export type SkillPickerSource = 'picker_list' | 'gallery' | 'skill_detail' | 'slash_command' | 'selected_chip' | 'keyboard'
export const SKILL_PICKER_SOURCE_VALUES: readonly SkillPickerSource[] = ['picker_list', 'gallery', 'skill_detail', 'slash_command', 'selected_chip', 'keyboard']

export type SkillPickerTab = 'builtin' | 'installed' | 'mine' | 'discover'
export const SKILL_PICKER_TAB_VALUES: readonly SkillPickerTab[] = ['builtin', 'installed', 'mine', 'discover']

export type SkillSource = 'built_in' | 'installed' | 'user_created' | 'repository'
export const SKILL_SOURCE_VALUES: readonly SkillSource[] = ['built_in', 'installed', 'user_created', 'repository']

export type StyleLibraryAction = 'select' | 'apply' | 'create_submitted' | 'use_created' | 'favorite_on' | 'favorite_off' | 'delete_confirmed'
export const STYLE_LIBRARY_ACTION_VALUES: readonly StyleLibraryAction[] = ['select', 'apply', 'create_submitted', 'use_created', 'favorite_on', 'favorite_off', 'delete_confirmed']

export type SurfaceLoadResult = 'ready' | 'error'
export const SURFACE_LOAD_RESULT_VALUES: readonly SurfaceLoadResult[] = ['ready', 'error']

export type TeamActorRole = 'owner' | 'admin' | 'member'
export const TEAM_ACTOR_ROLE_VALUES: readonly TeamActorRole[] = ['owner', 'admin', 'member']

export type TeamCreateEntryPoint = 'settings' | 'profile_flyout'
export const TEAM_CREATE_ENTRY_POINT_VALUES: readonly TeamCreateEntryPoint[] = ['settings', 'profile_flyout']

export type TeamShareEntryPoint = 'project_header' | 'dashboard'
export const TEAM_SHARE_ENTRY_POINT_VALUES: readonly TeamShareEntryPoint[] = ['project_header', 'dashboard']

export type TeamSwitchEntryPoint = 'header_switcher' | 'user_menu'
export const TEAM_SWITCH_ENTRY_POINT_VALUES: readonly TeamSwitchEntryPoint[] = ['header_switcher', 'user_menu']

export type TemplateAction = 'open' | 'use'
export const TEMPLATE_ACTION_VALUES: readonly TemplateAction[] = ['open', 'use']

export type TimelineEditAction = 'reverse' | 'freeze' | 'speed_curve' | 'trim' | 'split' | 'cut_left' | 'cut_right' | 'delete' | 'reorder' | 'add_track' | 'change_voice' | 'isolate_audio' | 'extract_native_audio'
export const TIMELINE_EDIT_ACTION_VALUES: readonly TimelineEditAction[] = ['reverse', 'freeze', 'speed_curve', 'trim', 'split', 'cut_left', 'cut_right', 'delete', 'reorder', 'add_track', 'change_voice', 'isolate_audio', 'extract_native_audio']

export type TimelineTrackKind = 'video' | 'audio' | 'text'
export const TIMELINE_TRACK_KIND_VALUES: readonly TimelineTrackKind[] = ['video', 'audio', 'text']

export type ToolbarEntryPoint = 'node_toolbar'
export const TOOLBAR_ENTRY_POINT_VALUES: readonly ToolbarEntryPoint[] = ['node_toolbar']

export type UiLocale = 'en' | 'ko' | 'vi'
export const UI_LOCALE_VALUES: readonly UiLocale[] = ['en', 'ko', 'vi']

export type UploadAssetType = 'image' | 'video' | 'audio' | 'document'
export const UPLOAD_ASSET_TYPE_VALUES: readonly UploadAssetType[] = ['image', 'video', 'audio', 'document']

export type UploadMenuEntryPoint = 'chat_sidebar'
export const UPLOAD_MENU_ENTRY_POINT_VALUES: readonly UploadMenuEntryPoint[] = ['chat_sidebar']

export type UploadProcessingStage = 'receive' | 'validate' | 'store' | 'register'
export const UPLOAD_PROCESSING_STAGE_VALUES: readonly UploadProcessingStage[] = ['receive', 'validate', 'store', 'register']

export type UploadSource = 'picker' | 'drag_drop' | 'prompt_attachment'
export const UPLOAD_SOURCE_VALUES: readonly UploadSource[] = ['picker', 'drag_drop', 'prompt_attachment']

export type VariantArchiveAction = 'archive' | 'restore'
export const VARIANT_ARCHIVE_ACTION_VALUES: readonly VariantArchiveAction[] = ['archive', 'restore']

export type VariantFilter = 'variants' | 'archived'
export const VARIANT_FILTER_VALUES: readonly VariantFilter[] = ['variants', 'archived']

export type VersionHistoryAction = 'save' | 'restore' | 'delete' | 'compare'
export const VERSION_HISTORY_ACTION_VALUES: readonly VersionHistoryAction[] = ['save', 'restore', 'delete', 'compare']

export type ViewModeTrigger = 'initial_load' | 'restore' | 'toggle'
export const VIEW_MODE_TRIGGER_VALUES: readonly ViewModeTrigger[] = ['initial_load', 'restore', 'toggle']

export type WorkspaceViewMode = 'canvas' | 'simplified'
export const WORKSPACE_VIEW_MODE_VALUES: readonly WorkspaceViewMode[] = ['canvas', 'simplified']

// ─── Event properties ───────────────────────────────────────────────────────

/** Operator explicitly starts a validated comma-delimited JSON intake. One event per click, regardless of recipient count; no preview or typing telemetry. */
export type AdminOnboardingIntakeSubmittedProps = {
  /** Single or CSV intake. */
  onboarding_mode: OnboardingIntakeMode
  /** Number of items requested or selected by one explicit user action (including up to 200 onboarding recipients). */
  count: number
}

/** Historical operator recovery/settlement opening action. Reserved with no current intake caller after partial recipients were prohibited. */
export type AdminOnboardingReconcileOpenedProps = {
  /** Single or CSV intake. */
  onboarding_mode: OnboardingIntakeMode
  /** Original onboarding run UUID. */
  onboarding_run_id: string
  /** Original target UUID; never recipient PII. */
  onboarding_target_id: string
}

/** Operator changes acknowledgement for displayed completed history. */
export type AdminOnboardingReonboardAcknowledgementChangedProps = {
  /** Single or CSV intake. */
  onboarding_mode: OnboardingIntakeMode
  /** Explicit checkbox state. */
  onboarding_acknowledged: boolean
  /** Number of items requested or selected by one explicit user action (including up to 200 onboarding recipients). */
  count: number
}

/** Historical operator resume action. Reserved with no current intake caller after partial recipients were prohibited. */
export type AdminOnboardingResumeClickedProps = {
  /** Single or CSV intake. */
  onboarding_mode: OnboardingIntakeMode
  /** Original onboarding run UUID. */
  onboarding_run_id?: string
  /** Original target UUID; never recipient PII. */
  onboarding_target_id?: string
  /** Number of items requested or selected by one explicit user action (including up to 200 onboarding recipients). */
  count: number
}

export type AppErrorUncaughtProps = {
  app_version: string
  area: AppArea
  error_kind: ErrorKind
  error_name: string
  error_site: string
  project_id?: string
}

export type AppInpReportedProps = {
  app_version: string
  inp_ms: number
  interaction_area: InteractionArea
  page_id: string
}

export type AppSessionStartedProps = {
  app_version: string
}

/** Unified download contract (doc P0), superseding canvas_video_download_initiated. One `initiated` row per asset attempt, recorded as the attempt hands off to the browser download (hidden iframe / anchor); `failed` only when that attempt fails observably in the client (no URL, URL build threw, HTTP error on a fetched blob, handoff threw). Never a saved/success row: browser download completion is not observable. Bulk actions share `bulk_action_id`. */
export type AssetDownloadActionProps = {
  project_id: string
  /** Random id minted per browser tab x workspace entry for a project; stable while the user stays in that workspace. */
  project_visit_id: string
  /** Random id minted per asset download attempt; an attempt's initiated and failed rows share it. */
  download_id: string
  /** What happened. Closed per event. */
  action: AssetDownloadAction
  entry_point: AssetDownloadEntryPoint
  download_kind: DownloadKind
  /** What was downloaded: a node's current output, a specific variant picked from a variants surface, or a whole-project export. */
  download_target: AssetDownloadTarget
  /** Workspace view at the time of the action: canvas or simplified (list view). */
  view_mode: WorkspaceViewMode
  /** Media type of the generated output that was viewed / loaded. */
  media_type?: OutputMediaType
  node_id?: string
  variant_id?: string
  format?: string
  /** Random id shared by every asset attempt started by one bulk download click. */
  bulk_action_id?: string
  /** Number of assets in the bulk download action. */
  bulk_count_bucket?: CountBucket
  /** Coarse failure class, failures only. Closed per event; never an error message. */
  error_category?: AssetDownloadErrorCategory
}

export type AuthSignedInProps = {
  method: AuthMethod
}

/** The user clicks Sign in in the landing navbar. */
export type AuthSigninClickedProps = {
  entry_point: SigninEntryPoint
}

export type AuthSigninFailedProps = {
  reason: SigninFailureReason
}

/** The user submits sign-in: clicks Continue with Google / Facebook, or submits the email sign-in form (before the result). */
export type AuthSigninSubmittedProps = {
  method: AuthMethod
}

export type AuthSignupClickedProps = {
  entry_point: string
}

export type AuthSignupSubmittedProps = {
  method: AuthMethod
}

/** Client: action=add_started when the BYOM Add-model form becomes visible. Server: action=test_result after a connection test reaches a terminal result, action=save_result after a configuration is persisted or fails. */
export type ByomActionProps = {
  /** What happened. Closed per event. */
  action: ByomAction
  /** BYOM model kind. */
  model_type: ByomModelType
  /** BYOM provider or preset id the add form starts on: the Director wire protocol, or the video preset. Never an endpoint or credential. */
  provider?: ByomProvider
  entry_point?: ByomEntryPoint
  /** BYOM model registrations the user has saved, across all model kinds. */
  configured_model_count_bucket?: CountBucket
  /** Opaque id of the BYOM configuration row. */
  model_config_id?: string
  /** Terminal outcome of the action. Closed per event. */
  result?: ActionResult
  /** Coarse failure class, failures only. Closed per event; never an error message. */
  error_category?: ServerResultErrorCategory
  /** Server-measured time from request receipt to the terminal result. */
  latency_bucket?: LatencyBucket
  /** The tested configuration was already saved (an edit), not a new one. */
  is_existing_configuration?: boolean
  /** True when this save created the user's first BYOM configuration. */
  is_first_model?: boolean
  /** Bucketed number of BYOM configurations the user has after the save. */
  configured_model_count_after?: CountBucket
}

/** Settings → General (the BYOM model settings surface) became visible. Once per open, after the saved model list request settles. Paused 2026-10-19: impression events are out of scope for the first release; no caller. */
export type ByomViewedProps = {
  entry_point: SettingsViewEntryPoint
  /** BYOM model registrations the user has saved, across all model kinds. */
  configured_model_count_bucket?: CountBucket
  /** BYOM model kinds (video, director, image) the surface lets this user configure. */
  provider_count_available: number
  /** Whether the viewer can change what the surface shows (false = read-only view). */
  editable: boolean
}

export type CanvasInsufficientTokensBlockProps = {
  balance_credits?: number
  blocked_action: BlockedAction
  project_id?: string
  required_credits?: number
}

export type CanvasAssetLoadFinishedProps = {
  app_version: string
  asset_kind: AssetKind
  duration_ms: number
  node_id?: string
  outcome: LoadOutcome
  project_id: string
  trigger: AssetTrigger
  /** Media type of the generated output that was viewed / loaded. */
  media_type?: OutputMediaType
  variant_id?: string
}

export type CanvasClipAddedToTimelineProps = {
  clip_id: string
  project_id: string
}

/** The user chose an enabled item in a canvas right-click menu. One row per click, logged before the item's action runs; the action's own outcome events (canvas_node_action, asset_download_action, ...) still fire as usual. node_id / node_type describe the right-clicked node and are absent on the canvas menu; item_count is how many selected nodes the item applies to (0 on the canvas menu). */
export type CanvasContextMenuActionProps = {
  project_id: string
  /** Which right-click menu the item was chosen from: node (right-click on a node or a multi-selection) or canvas (right-click on empty canvas or an edge). */
  menu: ContextMenuKind
  /** What happened. Closed per event. */
  action: ContextMenuAction
  /** Workspace view at the time of the action: canvas or simplified (list view). */
  view_mode: WorkspaceViewMode
  item_count: number
  node_id?: string
  /** Generated frontend node type id (videoGenerator, characterDesigner, …) — one spelling across every event; never the backend snake_case type. */
  node_type?: string
}

/** The user drags a connection between two node ports on the canvas (Director and collaborator edits never log). */
export type CanvasEdgeActionProps = {
  project_id: string
  /** What happened. Closed per event. */
  action: EdgeAction
  /** Frontend node type id of an edge's source node (e.g. imageGenerator). */
  from_node_type?: string
  /** Frontend node type id of an edge's target node. */
  to_node_type?: string
}

/** The user clicks Submit in the workspace feedback form. */
export type CanvasFeedbackSubmittedProps = {
  project_id?: string
  /** Feedback form category picked by the user. */
  category: FeedbackCategory
}

/** The user cancels a generation: inside the pre-submit undo window (stage=grace) or by stopping a submitted run (stage=running). */
export type CanvasGenerationCancelledProps = {
  project_id: string
  node_id: string
  /** Generated frontend node type id (videoGenerator, characterDesigner, …) — one spelling across every event; never the backend snake_case type. */
  node_type?: string
  /** grace = cancelled inside the pre-submit undo window; running = a submitted run was stopped. */
  stage: GenerationCancelStage
  /** Client-minted command id sent with the request (UUID). For execute-node it is the request_id stored in generation_executions.request_key. */
  request_id?: string
}

/** The user clicks a button in the out-of-credits modal (only Close exists today). */
export type CanvasInsufficientCreditsModalActionProps = {
  /** What happened. Closed per event. */
  action: InsufficientCreditsModalAction
  /** Why the out-of-credits modal was shown. Unknown is used when financial details are intentionally hidden. */
  block_reason: CreditsBlockReason
  blocked_action?: BlockedAction
  project_id?: string
  /** Whether the project (or wallet) in question belongs to the user's personal team or a shared team. */
  owner_type?: OwnerType
  /** Team UUID. */
  team_id?: string
}

export type CanvasLoadFinishedProps = {
  app_version: string
  canvas_id: string
  duration_ms: number
  node_count?: number
  outcome: LoadOutcome
  project_id: string
}

/** A user node mutation committed to the canvas YDoc: add, duplicate, change_type or delete. Director/agent mutations and drag/position updates are never logged. */
export type CanvasNodeActionProps = {
  project_id: string
  node_id: string
  /** Generated frontend node type id (videoGenerator, characterDesigner, …) — one spelling across every event; never the backend snake_case type. */
  node_type: string
  /** What happened. Closed per event. */
  action: NodeMutationAction
  source: NodeMutationSource
  /** Visible canvas nodes after the mutation committed. */
  node_count_after: number
}

export type CanvasNodeRenderFailedProps = {
  app_version: string
  error_name: string
  error_site: string
  node_id?: string
  /** Generated frontend node type id (videoGenerator, characterDesigner, …) — one spelling across every event; never the backend snake_case type. */
  node_type: string
  project_id: string
}

/** A click on a selected-node floating-toolbar tool (Add to chat, Save to library, Extract frame/audio, Depth, AI clips, Upscale, Panorama, Location angles, Fullscreen, Annotate). Duplicate, delete and download keep their own events. */
export type CanvasNodeToolbarActionProps = {
  project_id: string
  node_id: string
  /** Generated frontend node type id (videoGenerator, characterDesigner, …) — one spelling across every event; never the backend snake_case type. */
  node_type?: string
  /** The top-level toolbar function the interaction belongs to. */
  control: NodeToolbarControl
  /** The thing picked: a node type id, tool, tab key, rail category or target view mode. Code identifiers only, never user text. */
  option?: string
  /** Workspace view at the time of the action: canvas or simplified (list view). */
  view_mode?: WorkspaceViewMode
  /** Random id minted per browser tab x workspace entry for a project; stable while the user stays in that workspace. */
  project_visit_id?: string
  variant_id?: string
  entry_point?: ToolbarEntryPoint
  /** Random id minted on the top-level toolbar click and carried by every follow-up action inside the surface it opened, so a sub-action is attributable to its entry click. */
  interaction_id?: string
}

/** The user clicks play on a generated video in a node preview (autoplay never logs). */
export type CanvasOutputPlayClickedProps = {
  project_id: string
  node_id: string
  /** Generated frontend node type id (videoGenerator, characterDesigner, …) — one spelling across every event; never the backend snake_case type. */
  node_type?: string
  /** Media type of the generated output that was viewed / loaded. */
  media_type: OutputMediaType
}

/** A click on the workspace toolbars (canvas bottom palette, the palette in list view, list view's left rail) or on a follow-up action inside the surface that click opened. Follow-ups share the entry click's interaction_id. */
export type CanvasPaletteActionProps = {
  project_id: string
  /** Which toolbar the interaction started on: canvas_palette (canvas bottom palette), list_palette (the same palette in list view), list_rail (list view's left rail). */
  surface: PaletteSurface
  /** The top-level toolbar function the interaction belongs to. */
  control: PaletteControl
  /** What happened. Closed per event. */
  action: PaletteAction
  /** Random id minted on the top-level toolbar click and carried by every follow-up action inside the surface it opened, so a sub-action is attributable to its entry click. */
  interaction_id: string
  /** True on the top-level toolbar click that started the interaction; false on follow-up actions. */
  is_entry: boolean
  /** Workspace view at the time of the action: canvas or simplified (list view). */
  view_mode: WorkspaceViewMode
  /** The thing picked: a node type id, tool, tab key, rail category or target view mode. Code identifiers only, never user text. */
  option?: string
  item_count?: number
}

export type CanvasProjectExportedProps = {
  project_id: string
}

/** A user opens the Refine model picker, selects a different model, or opens the Style Library from Refine. Style selection and Save plan retain canvas_style_library_action; no impressions or background events. */
export type CanvasRefineControlActionProps = {
  project_id: string
  node_id: string
  /** Generated frontend node type id (videoGenerator, characterDesigner, …) — one spelling across every event; never the backend snake_case type. */
  node_type: string
  /** What happened. Closed per event. */
  action: RefineControlAction
  /** Opaque style id (public catalog slug, user-style UUID, or NO_STYLE). Never a display name. */
  style_id?: string
}

/** A user committed, undid, or redid an edit to an existing Shot List cell or relinked one frame slot. Contains no user-written text or image path. */
export type CanvasShotListEditActionProps = {
  project_id: string
  node_id: string
  /** The committed user edit in an existing Shot List cell or frame slot. */
  shot_list_edit_action: ShotListEditAction
  /** Whether the Shot List is guided, screenplay-bound, measured from video, or flat. */
  shot_list_edit_source: ShotListEditSource
  /** Schema field identifier of the edited cell, never its contents. */
  shot_list_edit_field?: string
  /** The existing start, key, or end frame slot that was relinked. */
  shot_list_edit_role?: ShotListEditRole
}

/** A click in the canvas Style Library: select a style, apply it on close, submit a new custom style, use a just-created style, favourite / unfavourite, or confirm deleting a custom style. The landing Style Library keeps landing_prompt_option_action. */
export type CanvasStyleLibraryActionProps = {
  project_id: string
  /** What happened. Closed per event. */
  action: StyleLibraryAction
  /** Opaque style id (public catalog slug, user-style UUID, or NO_STYLE). Never a display name. */
  style_id?: string
}

/** A user edit in the Video Editor timeline (split, cut, trim, delete, reorder, speed, reverse/freeze, add track, audio actions). */
export type CanvasTimelineEditActionProps = {
  project_id: string
  node_id?: string
  /** What happened. Closed per event. */
  action: TimelineEditAction
  /** Timeline track the edit applies to. */
  track_kind?: TimelineTrackKind
  /** Random id minted when the video editor opens; carried by every timeline edit made in that editor session. */
  editor_session_id?: string
}

/** Archiving or restoring a variant persisted (after the marker write succeeded). */
export type CanvasVariantArchiveChangedProps = {
  project_id: string
  node_id: string
  /** Generated frontend node type id (videoGenerator, characterDesigner, …) — one spelling across every event; never the backend snake_case type. */
  node_type: string
  /** What happened. Closed per event. */
  action: VariantArchiveAction
  variant_id: string
  /** 1-based position of the variant in its node's history (CountBucket). */
  variant_position_bucket: CountBucket
  /** How many variants the node has (CountBucket). */
  variant_count_bucket?: CountBucket
}

/** The user picked a different variant as the node's kept output (image and video nodes). variant_id is `${node_id}:${history_index}`. */
export type CanvasVariantKeptProps = {
  project_id: string
  variant_id: string
  node_id?: string
  /** Generated frontend node type id (videoGenerator, characterDesigner, …) — one spelling across every event; never the backend snake_case type. */
  node_type?: string
}

/** The user clicks Save, Restore, Delete or Compare in Version history, once the request settles. */
export type CanvasVersionHistoryActionProps = {
  project_id: string
  /** What happened. Closed per event. */
  action: VersionHistoryAction
  /** Terminal outcome of the action. Closed per event. */
  result: ActionResult
}

/** Superseded by asset_download_action (RFC-1577, doc P0 unified download contract): the console no longer emits it. Kept in the catalog so older clients still in the wild are accepted during rollout. */
export type CanvasVideoDownloadInitiatedProps = {
  download_kind: DownloadKind
  format?: string
  node_id: string
  project_id: string
  video_seconds?: number
}

/** The user picks files from the Director composer Upload menu (one event per pick and attachment type). */
export type ChatAttachmentAddedProps = {
  project_id?: string
  /** Kind of file the user attached in the Director composer. */
  attachment_type: AttachmentType
  /** How many files were attached in one pick, bucketed. */
  file_count_bucket?: CountBucket
}

/** The user answers a Director chat card by clicking (select / submit / skip / confirm / create / dismiss / finished / apply). Typed composer sends are project_prompt_submitted. */
export type ChatCardActionProps = {
  project_id: string
  /** Which Director chat card the user answered. */
  card_type: ChatCardType
  /** What happened. Closed per event. */
  action: ChatCardAction
  /** How many options the card offered, bucketed. */
  option_count_bucket?: CountBucket
  /** How many questions a batched card holds, bucketed. */
  question_count_bucket?: CountBucket
}

/** The user clicks Confirm or Cancel on the Director's priced execution plan card. */
export type ChatExecutionPlanActionProps = {
  project_id: string
  /** What happened. Closed per event. */
  action: ExecutionPlanAction
  /** Nodes on the active canvas when the event was recorded. */
  node_count_bucket?: CountBucket
  /** A credit amount shown to the user, bucketed. Never the exact amount. */
  credits_bucket?: CreditsBucket
}

/** The user clicks Send now, Edit or Remove on a queued Director prompt. */
export type ChatQueuedPromptActionProps = {
  project_id: string
  /** What happened. Closed per event. */
  action: QueuedPromptAction
}

/** The user clicks a skill-library action in the Skills detail view or editor: Install / Update / Uninstall / Publish / Delete / Use, or Save in the skill editor (save_version). */
export type ChatSkillLibraryActionProps = {
  project_id?: string
  /** What happened. Closed per event. */
  action: SkillLibraryAction
  /** Opaque runtime skill ref (builtin:<code slug>, user:<uuid>, published:<uuid>[@<uuid>]). Never a display name. */
  skill_ref?: string
  /** Opaque skill version UUID. */
  skill_version_id?: string
  /** built_in = shipped by Dreamwrite, installed = a published skill the user installed, user_created = a skill the user owns. */
  skill_source?: SkillSource
}

/** The user clicks Stop on a running Director turn. */
export type ChatTurnCancelledProps = {
  project_id: string
}

export type CheckoutInitiateClickProps = {
  amount_minor: number
  credits: number
  currency: string
  item_id: string
  source: CatalogSource
  /** Whether the project (or wallet) in question belongs to the user's personal team or a shared team. */
  owner_type?: OwnerType
  /** Team UUID. */
  team_id?: string
}

export type CheckoutRedirectBlockProps = {
  mft_order_id: string
  reason: RedirectBlockReason
}

export type CheckoutRedirectSubmitProps = {
  handoff_ttl_remaining_s: number
  mft_order_id: string
  payment_container_mode: PaymentContainerModeEvent
}

export type CheckoutReturnFailProps = {
  failure_reason?: string
  mft_order_id: string
}

export type CheckoutReturnSuccessProps = {
  elapsed_ms_since_handoff?: number
  mft_order_id: string
}

export type CheckoutReturnUnmatchedProps = {
  has_order_id: boolean
  reason: ReturnUnmatchedReason
}

/** The Director composer's upload flyout opened. Once per open. */
export type ComposerUploadMenuViewedProps = {
  project_id: string
  entry_point: UploadMenuEntryPoint
  item_count: number
}

/** The freshly created invite link was written to the clipboard (only after the write resolves). Never carries the invite token or link. */
export type CopyInviteLinkSucceededProps = {
  /** Team UUID. */
  team_id: string
  /** Team invite UUID. Never the invite token or link. */
  invite_id?: string
  /** Role the invite confers on join. */
  invite_role: InviteRole
  /** Invite TTL, as one of the expiry choices the invite panel offers. */
  expiry_bucket?: InviteExpiryBucket
  entry_point?: SettingsViewEntryPoint
  /** The acting user's role in the team the surface is showing. */
  actor_role: TeamActorRole
}

/** An enabled Create link click in Settings → Teams (before the request; link creation is measured from backend invite facts). Never carries the invite token or link. */
export type CreateInviteLinkClickedProps = {
  /** Team UUID. */
  team_id: string
  /** Role the invite confers on join. */
  invite_role: InviteRole
  /** Invite TTL, as one of the expiry choices the invite panel offers. */
  expiry_bucket?: InviteExpiryBucket
  entry_point?: SettingsViewEntryPoint
  /** The acting user's role in the team the surface is showing. */
  actor_role: TeamActorRole
}

/** An enabled Create-team submit. Successful creation is measured from the teams table, not here. */
export type CreateTeamClickedProps = {
  entry_point: TeamCreateEntryPoint
}

/** The user clicks a project card on the dashboard to open it. */
export type DashboardProjectOpenedProps = {
  project_id: string
  /** Whether the project (or wallet) in question belongs to the user's personal team or a shared team. */
  owner_type?: OwnerType
}

/** An action in the Director composer's skills picker: open (the picker becomes visible), tab_view (once per tab activation per open, including the initial tab), select (a skill became the selected skill), clear (the selected skill was removed). All actions of one open share picker_open_id. A clear from the selected-skill chip (x) or by deleting it with the keyboard carries source and no picker_open_id. */
export type DirectorSkillsPickerActionProps = {
  project_id: string
  /** What happened. Closed per event. */
  action: SkillPickerAction
  /** Random id minted each time the Director skills picker opens; every action of that open carries it. */
  picker_open_id?: string
  /** Code key of the tab the action happened on. Closed per event. */
  tab?: SkillPickerTab
  /** Opaque runtime skill ref (builtin:<code slug>, user:<uuid>, published:<uuid>[@<uuid>]). Never a display name. */
  skill_ref?: string
  /** Opaque skill version UUID. */
  skill_version_id?: string
  /** built_in = shipped by Dreamwrite, installed = a published skill the user installed, user_created = a skill the user owns. */
  skill_source?: SkillSource
  /** Skills listed on the picker tab the action happened on (after the catalog loaded; search filter not applied). */
  available_skill_count_bucket?: CountBucket
  source?: SkillPickerSource
  entry_point?: SkillPickerEntryPoint
  /** Published skills the user has installed (CountBucket), once the picker's catalog has loaded. */
  installed_skill_count_bucket?: CountBucket
  /** 1-based position of the picked skill in the list it was picked from (CountBucket). */
  selection_position_bucket?: CountBucket
}

/** First qualified view of a generated result per (project_visit_id, node_id, variant_id, view_type). Image: the output is >=50% visible for >=1s while the document is visible. Video/audio: the media element's actual `playing` event. Uploads, placeholders and posters never qualify. Paused 2026-10-19: impression events are out of scope for the first release; no caller. */
export type GeneratedOutputViewedProps = {
  project_id: string
  /** Random id minted per browser tab x workspace entry for a project; stable while the user stays in that workspace. */
  project_visit_id: string
  node_id: string
  /** Generated frontend node type id (videoGenerator, characterDesigner, …) — one spelling across every event; never the backend snake_case type. */
  node_type: string
  variant_id?: string
  /** Media type of the generated output that was viewed / loaded. */
  media_type: OutputMediaType
  /** How the generated output qualified as viewed: image >=50% visible for >=1s while the document is visible, or the media element's first `playing` event. */
  view_type: OutputViewType
  entry_point: OutputViewEntryPoint
  /** manual = an explicit play action (play button, frame click, Play All); autoplay = playback the UI started on its own (hover preview). */
  playback_trigger?: PlaybackTrigger
  /** Workspace view at the time of the action: canvas or simplified (list view). */
  view_mode: WorkspaceViewMode
}

/** The user clicked the Advanced disclosure in the landing Project setup modal to expand or collapse it. Only explicit clicks; the modal opening with Advanced already expanded (because it holds content) does not emit. */
export type LandingPageProjectSetupAdvancedToggledProps = {
  /** Advanced disclosure state after the click: true = expanded, false = collapsed. */
  expanded: boolean
  /** At the moment of the click, at least one Advanced field (title, logline, storyline, tone, structure) is non-empty. */
  has_advanced_content: boolean
  is_authenticated: boolean
}

export type LandingPagePromptConsoleStartedProps = {
  is_authenticated: boolean
  prompt_len: number
}

export type LandingPagePromptSubmittedProps = {
  is_authenticated: boolean
  prompt_len: number
  prompt_length_bucket?: LengthBucket
  /** Opaque style id (public catalog slug, user-style UUID, or NO_STYLE). Never a display name. */
  style_id?: string
  /** True when the submitted style is the landing default (NO_STYLE). */
  style_is_default?: boolean
  /** At least one queued upload (image / video / audio) rides the submit. Documents are not assets. */
  has_assets?: boolean
  /** Distinct queued upload types (image / video / audio) on the submit. */
  asset_type_count?: number
  /** At least one Project setup setting differs from its default at submit. Omitted while Project setup is feature-gated off. */
  project_setup_changed?: boolean
  /** Project setup settings that differ: on an option action, changed by that commit; on prompt submit, differing from the defaults. */
  changed_setting_count_bucket?: CountBucket
}

export type LandingPageViewProps = {
  referrer_host?: string
  utm_campaign?: string
  utm_source?: string
}

/** The landing prompt's Style library or Project setup was opened, or a selection in it was committed (change, or reset back to the default). Never hover or per-control movement. */
export type LandingPromptOptionActionProps = {
  /** Which landing prompt option surface: the Style library or the Project setup modal. */
  option_type: LandingPromptOptionType
  /** What happened. Closed per event. */
  action: LandingPromptOptionAction
  /** Opaque style id (public catalog slug, user-style UUID, or NO_STYLE). Never a display name. */
  style_id?: string
  /** The style's group from the closed STYLE_GROUPS vocabulary; custom = user-created style, none = NO_STYLE, other = public style with no recognized group. */
  style_family?: LandingStyleFamily
  /** True when the option was in its landing default state before this action (style NO_STYLE; project setup with no changed setting). */
  was_default_before: boolean
  /** Project setup settings that differ: on an option action, changed by that commit; on prompt submit, differing from the defaults. */
  changed_setting_count_bucket?: CountBucket
  is_authenticated: boolean
}

/** The landing Stories gallery became at least 50% visible. Once per landing page view. Paused 2026-10-19: impression events are out of scope for the first release; no caller. */
export type LandingStoryGalleryViewedProps = {
  /** Story cards rendered in the landing Stories gallery. */
  eligible_story_count: number
  is_authenticated: boolean
}

/** The expanded Stories player became visible after a card click or the fullscreen button. Once per open. */
export type LandingStoryOpenedProps = {
  /** Opaque gallery story id (the code-side slug), never a title. */
  story_id: string
  /** 1-based position of the story card in the gallery. */
  card_position: number
  trigger: LandingStoryOpenTrigger
  /** Whether the card's inline hover preview was playing when the story was opened. */
  preview_was_active: boolean
}

/** A Stories card's inline hover preview actually started playing (media 'playing' event). Once per hover. */
export type LandingStoryPreviewStartedProps = {
  /** Opaque gallery story id (the code-side slug), never a title. */
  story_id: string
  /** 1-based position of the story card in the gallery. */
  card_position: number
  trigger: LandingStoryPreviewTrigger
  /** Whether the preview video was muted when playback started. */
  muted: boolean
}

/** A node execute-node command is about to be sent (emitted inside executeNode() immediately before the request). request_id joins to generation_executions.request_key. */
export type NodeGenerationSubmittedProps = {
  /** Client-minted command id sent with the request (UUID). For execute-node it is the request_id stored in generation_executions.request_key. */
  request_id: string
  project_id: string
  node_id: string
  /** Generated frontend node type id (videoGenerator, characterDesigner, …) — one spelling across every event; never the backend snake_case type. */
  node_type?: string
  /** What happened. Closed per event. */
  action: ExecuteNodeAction
  /** Code key of the tab the action happened on. Closed per event. */
  tab?: NodePanelTab
  /** initial = node had no output; retry = regenerate a node that already has output; refine = Refine with feedback. */
  generation_mode?: GenerationMode
  /** Number of items requested or selected by one explicit user action (including up to 200 onboarding recipients). */
  count: number
  /** A refine carried a drawn annotation. */
  has_annotation?: boolean
  /** Reference inputs attached to the node at submit time. */
  reference_count?: number
  model_source?: ModelSource
  /** Random id minted per browser tab x workspace entry for a project; stable while the user stays in that workspace. */
  project_visit_id?: string
  /** Whether the project (or wallet) in question belongs to the user's personal team or a shared team. */
  owner_type?: OwnerType
  /** Team UUID. */
  team_id?: string
  /** The acting user's role in the team the surface is showing. */
  actor_role?: TeamActorRole
}

/** A tab of the selected node's bottom panel became active and visible (including the tab the panel opens on). Once per activation. Switching the Variants/Archived chip inside Variants re-logs tab=variants with the new variant_filter. Paused 2026-10-19: impression events are out of scope for the first release; no caller. */
export type NodePanelViewedProps = {
  project_id: string
  node_id: string
  /** Generated frontend node type id (videoGenerator, characterDesigner, …) — one spelling across every event; never the backend snake_case type. */
  node_type: string
  /** Code key of the tab the action happened on. Closed per event. */
  tab: NodePanelTab
  /** Variants / Archived chip inside the Variants tab. */
  variant_filter?: VariantFilter
  /** The node offers an enabled Refine tab in its current state. */
  refine_eligible: boolean
  /** The node offers a Variants view in its current state. */
  variants_eligible: boolean
  /** The node offers an enabled audio tab (Voice / Audio lanes) in its current state. */
  audio_eligible: boolean
  /** The node already has a generated output. */
  has_output: boolean
  /** How many variants the node has (CountBucket). */
  variant_count_bucket: CountBucket
}

/** A first-use Dreamwrite NUX tooltip was skipped or auto-completed. Tooltip copy and user content are never logged. */
export type NuxTooltipDismissedProps = {
  /** Stable NUX tooltip id. Never tooltip text. */
  tooltip_id: string
  app_area: AppArea
  dismiss_source: NuxDismissSource
  /** Generated frontend node type id (videoGenerator, characterDesigner, …) — one spelling across every event; never the backend snake_case type. */
  node_type?: string
}

/** A first-use Dreamwrite NUX tooltip became visible to an authenticated user. Tooltip copy and user content are never logged. */
export type NuxTooltipShownProps = {
  /** Stable NUX tooltip id. Never tooltip text. */
  tooltip_id: string
  app_area: AppArea
  /** Generated frontend node type id (videoGenerator, characterDesigner, …) — one spelling across every event; never the backend snake_case type. */
  node_type?: string
}

/** An enabled New Project click on the dashboard (header, empty tab, or first-project hero). */
export type ProjectCreateClickedProps = {
  entry_point: ProjectCreateEntryPoint
  /** Whether the project (or wallet) in question belongs to the user's personal team or a shared team. */
  owner_type?: OwnerType
  /** Team UUID. */
  team_id?: string
  /** Random id minted on a New Project click and carried to project creation, so the intent joins the project it created. */
  project_creation_intent_id: string
  /** Which product surface created the project. */
  creation_source: ProjectCreationSource
}

/** The user clicks Open editor on a Video Editor node. Fires on the click (name from the analytics doc). */
export type ProjectEditorViewedProps = {
  project_id: string
  node_id: string
  entry_point: EditorEntryPoint
  canvas_id?: string
  /** Random id minted per browser tab x workspace entry for a project; stable while the user stays in that workspace. */
  project_visit_id?: string
  /** Random id minted when the video editor opens; carried by every timeline edit made in that editor session. */
  editor_session_id?: string
  /** Workspace view at the time of the action: canvas or simplified (list view). */
  view_mode?: WorkspaceViewMode
  /** Whether the viewer can change what the surface shows (false = read-only view). */
  editable?: boolean
}

/** A click on a workspace header control that opens or starts its surface (a click that closes an open popover is not counted). */
export type ProjectHeaderControlClickedProps = {
  project_id: string
  /** Random id minted on the top-level toolbar click and carried by every follow-up action inside the surface it opened, so a sub-action is attributable to its entry click. */
  interaction_id: string
  /** The top-level toolbar function the interaction belongs to. */
  control: HeaderControl
  /** Whether the viewer can change what the surface shows (false = read-only view). */
  editable?: boolean
  /** Workspace view at the time of the action: canvas or simplified (list view). */
  view_mode?: WorkspaceViewMode
  /** Whether the project (or wallet) in question belongs to the user's personal team or a shared team. */
  owner_type?: OwnerType
  entry_point?: HeaderEntryPoint
}

/** A workspace header surface (Director Desk, Version History, Project Settings, Publish) became visible and interactive. Once per open, after its initial load settled. Paused 2026-10-19: impression events are out of scope for the first release; no caller. */
export type ProjectHeaderSurfaceViewedProps = {
  /** The interaction_id of the project_header_control_clicked row that opened this surface; omitted when it was entered any other way (deep link, chat card). */
  interaction_id?: string
  project_id: string
  /** Which header surface became visible. */
  surface: HeaderSurface
  /** header_click = opened by a header control click; deeplink = Director Desk entered from its URL (direct load, reload, browser history); chat_card = Project Settings opened from a Director chat card; other = any other entry. */
  entry_point: HeaderSurfaceEntryPoint
  /** How the surface's first load ended when it became visible: ready = its data loaded and it is interactive, error = its initial load failed. */
  load_result: SurfaceLoadResult
  /** The editable value the opening header click carried (false on read-only demo projects); omitted for other entries. */
  editable?: boolean
}

/** Project workspace lifecycle for one project_visit_id: enter on workspace entry, visibility_change on document visibility changes, heartbeat about every 60s only while the document is visible, best-effort exit on leaving the workspace or pagehide. Paused 2026-10-19: impression events are out of scope for the first release; no caller. */
export type ProjectPresenceUpdatedProps = {
  project_id: string
  /** Random id minted per browser tab x workspace entry for a project; stable while the user stays in that workspace. */
  project_visit_id: string
  /** What happened. Closed per event. */
  action: PresenceAction
  /** document.visibilityState when the presence event was recorded. */
  visibility_state: PageVisibilityState
  /** Workspace view at the time of the action: canvas or simplified (list view). */
  view_mode: WorkspaceViewMode
}

/** A Director turn. Client (prompt_source=composer): a composer turn the API accepted (POST /agent/connect returned 2xx). Server (prompt_source=auto): a turn the backend started on its own (the doc's 'BE auto call'). No message text. */
export type ProjectPromptSubmittedProps = {
  project_id: string
  /** The Director turn carries a selected skill. */
  has_skill: boolean
  /** The Director turn references at least one canvas node (@ mention). */
  has_mentions: boolean
  /** Documents attached to the composer turn. */
  attachment_count: number
  /** Opaque runtime skill ref (builtin:<code slug>, user:<uuid>, published:<uuid>[@<uuid>]). Never a display name. */
  skill_ref?: string
  /** Opaque skill version UUID. */
  skill_version_id?: string
  /** composer = a user's Director turn; auto = a turn the backend started on its own. */
  prompt_source?: PromptSource
  /** Why the backend started an automatic Director turn (closed set, see the event). */
  auto_reason?: AutoPromptReason
  entry_point?: UploadMenuEntryPoint
  canvas_id?: string
  /** Random id minted per browser tab x workspace entry for a project; stable while the user stays in that workspace. */
  project_visit_id?: string
  /** Workspace view at the time of the action: canvas or simplified (list view). */
  view_mode?: WorkspaceViewMode
  /** Random id minted on the top-level toolbar click and carried by every follow-up action inside the surface it opened, so a sub-action is attributable to its entry click. */
  interaction_id?: string
  /** At least one referenced node came from a composer upload. */
  reference_from_upload?: boolean
  /** At least one referenced node was added by typing an @mention. */
  reference_from_mention?: boolean
  /** At least one referenced node was added with the node toolbar Add to chat. */
  reference_from_add_to_chat?: boolean
}

/** A publish-popover action settled: publish / new_version / unpublish after the mutation succeeds or fails; copy_link after the clipboard write succeeds. A publish waiting on the excluded-canvases confirmation has not settled and is not recorded until it does. */
export type ProjectPublishResultProps = {
  project_id: string
  /** What happened. Closed per event. */
  action: PublishAction
  /** Terminal outcome of the action. Closed per event. */
  result: ActionResult
  /** Coarse failure class, failures only. Closed per event; never an error message. */
  error_category?: PublishErrorCategory
  /** Published versions the project had when the action was taken. */
  version_count_bucket?: CountBucket
}

/** A Project Settings value was saved (localStorage write or project-config save resolved). Values are categories only. */
export type ProjectSettingChangedProps = {
  project_id: string
  /** Which Project Settings control was saved. */
  setting_key: ProjectSettingKey
  /** Category of the saved value: on/off for toggles, the closed option for aspect ratio and output quality, auto/explicit for style, language and model choices. Never the raw value. */
  new_value_category: SettingValueCategory
  /** Category of the value before the save, same scale as new_value_category. */
  previous_value_category?: SettingValueCategory
}

/** A workspace view (canvas or simplified list) became active and visible: once when the workspace first becomes interactive, and once per later switch. Paused 2026-10-19: impression events are out of scope for the first release; no caller. */
export type ProjectViewModeViewedProps = {
  project_id: string
  /** Workspace view at the time of the action: canvas or simplified (list view). */
  view_mode: WorkspaceViewMode
  trigger: ViewModeTrigger
  /** The workspace view that was active before this one; omitted on the first activation. */
  previous_mode?: WorkspaceViewMode
  /** Nodes on the active canvas when the event was recorded. */
  node_count_bucket?: CountBucket
}

/** A signed-in user clicks Remix (clone) on a published project page (the button is shown only when signed in). */
export type PublishedProjectCloneClickedProps = Record<string, never>

/** My Rules (Settings → Personalization) or Project Rules became active and visible. Once per open, after the rules document has loaded. Paused 2026-10-19: impression events are out of scope for the first release; no caller. */
export type RulesSurfaceViewedProps = {
  /** Which rules store the surface edits: the user's own rules or a project's. */
  scope: RulesScope
  project_id?: string
  entry_point: RulesEntryPoint
  /** Whether the viewer can change what the surface shows (false = read-only view). */
  editable: boolean
  /** True when the loaded rules document has a non-blank body or any structured entry. */
  has_existing_rules: boolean
  /** Non-blank body lines plus structured entries in the loaded rules document. */
  rule_count_bucket: CountBucket
}

export type SettingsTokenCatalogViewProps = {
  currency?: string
  item_count: number
  source: CatalogSource
}

export type SettingsUsageAndTokensViewProps = {
  balance_credits?: number
  entry_point: CreditsEntryPoint
}

/** The user clicks Create or Revoke on an API key, once the request settles. */
export type SettingsApiKeyActionProps = {
  /** What happened. Closed per event. */
  action: ApiKeyAction
  /** Terminal outcome of the action. Closed per event. */
  result: ActionResult
}

/** The user changes the video model used to initialize new projects in Settings. */
export type SettingsDefaultVideoModelChangedProps = {
  model_source?: ProfileVideoModelSource
}

/** The user picks a Director model in Settings. */
export type SettingsDirectorModelChangedProps = {
  model_source?: ModelSource
}

/** The user saves a new display name, or picks a UI language, in Settings › Profile. */
export type SettingsProfileChangedProps = {
  /** Which Project Settings control was saved. */
  setting_key: ProfileSettingKey
  /** UI language the user picked. */
  ui_locale?: UiLocale
}

/** A click in the Rules editor: Save (once settled), Revert to a history version, Insert example, or Discard unsaved changes. The persisted outcome is the server rules_save_result. */
export type SettingsRulesActionProps = {
  /** What happened. Closed per event. */
  action: RulesAction
  /** Which rules store the surface edits: the user's own rules or a project's. */
  scope: RulesScope
  project_id?: string
  /** Terminal outcome of the action. Closed per event. */
  result?: ActionResult
}

/** Settings → Teams became the active, visible Settings section. Once per activation (the section remounts on every activation), not per render; emitted once the team list has loaded. Paused 2026-10-19: impression events are out of scope for the first release; no caller. */
export type TeamSectionViewedProps = {
  entry_point: SettingsViewEntryPoint
  /** True when the user belongs to more than one team (personal team included). */
  has_multiple_teams: boolean
  /** The acting user's role in the team the surface is showing. */
  actor_role?: TeamActorRole
}

/** The user picks a different team in the header team switcher or the user-menu team flyout (this changes which wallet new projects charge). */
export type TeamsActiveTeamSwitchedProps = {
  /** Team UUID. */
  team_id: string
  entry_point: TeamSwitchEntryPoint
  /** Whether the project (or wallet) in question belongs to the user's personal team or a shared team. */
  owner_type: OwnerType
  /** How many teams the user belongs to, bucketed. */
  team_count_bucket?: CountBucket
  /** The acting user's role in the team the surface is showing. */
  actor_role?: TeamActorRole
}

/** The user clicks Join on a team invite page, once the redeem request settles. */
export type TeamsInviteJoinClickedProps = {
  /** Team UUID. */
  team_id?: string
  /** Terminal outcome of the action. Closed per event. */
  result: ActionResult
}

/** An Owner/Admin clicks in a member's spending-limit editor: opens it (edit_opened), or Save (set) / Clear (clear) once the request settles. */
export type TeamsMemberAllowanceActionProps = {
  /** Team UUID. */
  team_id: string
  /** What happened. Closed per event. */
  action: AllowanceAction
  /** Terminal outcome of the action. Closed per event. */
  result?: ActionResult
  /** Member spending-limit type chosen in the editor. */
  limit_type?: AllowanceLimitType
  /** The member's limit type before this change (no_limit when uncapped). */
  previous_limit_type?: AllowanceLimitType
  /** Reset period of a recurring spending limit. */
  period?: AllowancePeriod
  /** The spending limit in credits, bucketed. Never the exact amount. */
  limit_bucket?: CreditsBucket
  /** Role of the member the action is applied to. */
  target_member_role?: TeamActorRole
  /** The acting user's role in the team the surface is showing. */
  actor_role?: TeamActorRole
}

/** An Owner/Admin confirms removing a member, once the request settles. */
export type TeamsMemberRemovedProps = {
  /** Team UUID. */
  team_id: string
  /** Role of the member the action is applied to. */
  target_member_role?: TeamActorRole
  /** The acting user's role in the team the surface is showing. */
  actor_role?: TeamActorRole
  /** Terminal outcome of the action. Closed per event. */
  result: ActionResult
}

/** An Owner/Admin picks a new role for a member, once the request settles. */
export type TeamsMemberRoleChangedProps = {
  /** Team UUID. */
  team_id: string
  /** Member role before a role change. */
  from_role?: TeamActorRole
  /** Member role picked in a role change. */
  to_role: TeamActorRole
  /** The acting user's role in the team the surface is showing. */
  actor_role?: TeamActorRole
  /** Terminal outcome of the action. Closed per event. */
  result: ActionResult
}

/** The user confirms sharing a project with its team (project header visibility pill, or dashboard Move to team), once the request settles. */
export type TeamsProjectSharedProps = {
  project_id: string
  entry_point: TeamShareEntryPoint
  /** Terminal outcome of the action. Closed per event. */
  result: ActionResult
  /** Team UUID. */
  team_id?: string
}

/** The Owner confirms deleting a team, once the request settles. */
export type TeamsTeamDeletedProps = {
  /** Team UUID. */
  team_id: string
  /** Team member count, bucketed. */
  member_count_bucket?: CountBucket
  /** Terminal outcome of the action. Closed per event. */
  result: ActionResult
}

/** The user confirms leaving a team, once the request settles. */
export type TeamsTeamLeftProps = {
  /** Team UUID. */
  team_id: string
  /** The acting user's role in the team the surface is showing. */
  actor_role?: TeamActorRole
  /** Terminal outcome of the action. Closed per event. */
  result: ActionResult
}

/** The user opens a template, or clicks Use template, in the templates gallery. */
export type TemplatesTemplateClickedProps = {
  /** What happened. Closed per event. */
  action: TemplateAction
  is_authenticated?: boolean
}

export type TokenCatalogOptionClickProps = {
  amount_minor: number
  credits: number
  currency: string
  discount_percent?: number
  item_id: string
  recommended?: boolean
  source: CatalogSource
  /** Whether the project (or wallet) in question belongs to the user's personal team or a shared team. */
  owner_type?: OwnerType
  /** Team UUID. */
  team_id?: string
}

// ─── Event map ──────────────────────────────────────────────────────────────

/** Every client event name (active and reserved) mapped to its properties. */
export type ClientAnalyticsEventProps = {
  'admin_onboarding_intake_submitted': AdminOnboardingIntakeSubmittedProps
  'admin_onboarding_reconcile_opened': AdminOnboardingReconcileOpenedProps
  'admin_onboarding_reonboard_acknowledgement_changed': AdminOnboardingReonboardAcknowledgementChangedProps
  'admin_onboarding_resume_clicked': AdminOnboardingResumeClickedProps
  'app_error_uncaught': AppErrorUncaughtProps
  'app_inp_reported': AppInpReportedProps
  'app_session_started': AppSessionStartedProps
  'asset_download_action': AssetDownloadActionProps
  'auth_signed_in': AuthSignedInProps
  'auth_signin_clicked': AuthSigninClickedProps
  'auth_signin_failed': AuthSigninFailedProps
  'auth_signin_submitted': AuthSigninSubmittedProps
  'auth_signup_clicked': AuthSignupClickedProps
  'auth_signup_submitted': AuthSignupSubmittedProps
  'byom_action': ByomActionProps
  'byom_viewed': ByomViewedProps
  'canvas.insufficient_tokens.block': CanvasInsufficientTokensBlockProps
  'canvas_asset_load_finished': CanvasAssetLoadFinishedProps
  'canvas_clip_added_to_timeline': CanvasClipAddedToTimelineProps
  'canvas_context_menu_action': CanvasContextMenuActionProps
  'canvas_edge_action': CanvasEdgeActionProps
  'canvas_feedback_submitted': CanvasFeedbackSubmittedProps
  'canvas_generation_cancelled': CanvasGenerationCancelledProps
  'canvas_insufficient_credits_modal_action': CanvasInsufficientCreditsModalActionProps
  'canvas_load_finished': CanvasLoadFinishedProps
  'canvas_node_action': CanvasNodeActionProps
  'canvas_node_render_failed': CanvasNodeRenderFailedProps
  'canvas_node_toolbar_action': CanvasNodeToolbarActionProps
  'canvas_output_play_clicked': CanvasOutputPlayClickedProps
  'canvas_palette_action': CanvasPaletteActionProps
  'canvas_project_exported': CanvasProjectExportedProps
  'canvas_refine_control_action': CanvasRefineControlActionProps
  'canvas_shot_list_edit_action': CanvasShotListEditActionProps
  'canvas_style_library_action': CanvasStyleLibraryActionProps
  'canvas_timeline_edit_action': CanvasTimelineEditActionProps
  'canvas_variant_archive_changed': CanvasVariantArchiveChangedProps
  'canvas_variant_kept': CanvasVariantKeptProps
  'canvas_version_history_action': CanvasVersionHistoryActionProps
  'canvas_video_download_initiated': CanvasVideoDownloadInitiatedProps
  'chat_attachment_added': ChatAttachmentAddedProps
  'chat_card_action': ChatCardActionProps
  'chat_execution_plan_action': ChatExecutionPlanActionProps
  'chat_queued_prompt_action': ChatQueuedPromptActionProps
  'chat_skill_library_action': ChatSkillLibraryActionProps
  'chat_turn_cancelled': ChatTurnCancelledProps
  'checkout.initiate.click': CheckoutInitiateClickProps
  'checkout.redirect.block': CheckoutRedirectBlockProps
  'checkout.redirect.submit': CheckoutRedirectSubmitProps
  'checkout.return.fail': CheckoutReturnFailProps
  'checkout.return.success': CheckoutReturnSuccessProps
  'checkout.return.unmatched': CheckoutReturnUnmatchedProps
  'composer_upload_menu_viewed': ComposerUploadMenuViewedProps
  'copy_invite_link_succeeded': CopyInviteLinkSucceededProps
  'create_invite_link_clicked': CreateInviteLinkClickedProps
  'create_team_clicked': CreateTeamClickedProps
  'dashboard_project_opened': DashboardProjectOpenedProps
  'director_skills_picker_action': DirectorSkillsPickerActionProps
  'generated_output_viewed': GeneratedOutputViewedProps
  'landing_page_project_setup_advanced_toggled': LandingPageProjectSetupAdvancedToggledProps
  'landing_page_prompt_console_started': LandingPagePromptConsoleStartedProps
  'landing_page_prompt_submitted': LandingPagePromptSubmittedProps
  'landing_page_view': LandingPageViewProps
  'landing_prompt_option_action': LandingPromptOptionActionProps
  'landing_story_gallery_viewed': LandingStoryGalleryViewedProps
  'landing_story_opened': LandingStoryOpenedProps
  'landing_story_preview_started': LandingStoryPreviewStartedProps
  'node_generation_submitted': NodeGenerationSubmittedProps
  'node_panel_viewed': NodePanelViewedProps
  'nux_tooltip_dismissed': NuxTooltipDismissedProps
  'nux_tooltip_shown': NuxTooltipShownProps
  'project_create_clicked': ProjectCreateClickedProps
  'project_editor_viewed': ProjectEditorViewedProps
  'project_header_control_clicked': ProjectHeaderControlClickedProps
  'project_header_surface_viewed': ProjectHeaderSurfaceViewedProps
  'project_presence_updated': ProjectPresenceUpdatedProps
  'project_prompt_submitted': ProjectPromptSubmittedProps
  'project_publish_result': ProjectPublishResultProps
  'project_setting_changed': ProjectSettingChangedProps
  'project_view_mode_viewed': ProjectViewModeViewedProps
  'published_project_clone_clicked': PublishedProjectCloneClickedProps
  'rules_surface_viewed': RulesSurfaceViewedProps
  'settings.token_catalog.view': SettingsTokenCatalogViewProps
  'settings.usage_and_tokens.view': SettingsUsageAndTokensViewProps
  'settings_api_key_action': SettingsApiKeyActionProps
  'settings_default_video_model_changed': SettingsDefaultVideoModelChangedProps
  'settings_director_model_changed': SettingsDirectorModelChangedProps
  'settings_profile_changed': SettingsProfileChangedProps
  'settings_rules_action': SettingsRulesActionProps
  'team_section_viewed': TeamSectionViewedProps
  'teams_active_team_switched': TeamsActiveTeamSwitchedProps
  'teams_invite_join_clicked': TeamsInviteJoinClickedProps
  'teams_member_allowance_action': TeamsMemberAllowanceActionProps
  'teams_member_removed': TeamsMemberRemovedProps
  'teams_member_role_changed': TeamsMemberRoleChangedProps
  'teams_project_shared': TeamsProjectSharedProps
  'teams_team_deleted': TeamsTeamDeletedProps
  'teams_team_left': TeamsTeamLeftProps
  'templates_template_clicked': TemplatesTemplateClickedProps
  'token_catalog.option.click': TokenCatalogOptionClickProps
}

export type ClientAnalyticsEventName = keyof ClientAnalyticsEventProps

/** Client events delivered by sendBeacon on page-hide (anonymous, no auth header). */
export type BeaconAnalyticsEventName = 'app_inp_reported'

/** True ⇒ the emitter attaches the GoTrue JWT and the collector derives user_id. */
export const CLIENT_ANALYTICS_EVENT_AUTHENTICATED: { readonly [N in ClientAnalyticsEventName]: boolean } = {
  'admin_onboarding_intake_submitted': true,
  'admin_onboarding_reconcile_opened': true,
  'admin_onboarding_reonboard_acknowledgement_changed': true,
  'admin_onboarding_resume_clicked': true,
  'app_error_uncaught': true,
  'app_inp_reported': false,
  'app_session_started': true,
  'asset_download_action': true,
  'auth_signed_in': true,
  'auth_signin_clicked': false,
  'auth_signin_failed': false,
  'auth_signin_submitted': false,
  'auth_signup_clicked': false,
  'auth_signup_submitted': false,
  'byom_action': true,
  'byom_viewed': true,
  'canvas.insufficient_tokens.block': true,
  'canvas_asset_load_finished': true,
  'canvas_clip_added_to_timeline': true,
  'canvas_context_menu_action': true,
  'canvas_edge_action': true,
  'canvas_feedback_submitted': true,
  'canvas_generation_cancelled': true,
  'canvas_insufficient_credits_modal_action': true,
  'canvas_load_finished': true,
  'canvas_node_action': true,
  'canvas_node_render_failed': true,
  'canvas_node_toolbar_action': true,
  'canvas_output_play_clicked': true,
  'canvas_palette_action': true,
  'canvas_project_exported': true,
  'canvas_refine_control_action': true,
  'canvas_shot_list_edit_action': true,
  'canvas_style_library_action': true,
  'canvas_timeline_edit_action': true,
  'canvas_variant_archive_changed': true,
  'canvas_variant_kept': true,
  'canvas_version_history_action': true,
  'canvas_video_download_initiated': true,
  'chat_attachment_added': true,
  'chat_card_action': true,
  'chat_execution_plan_action': true,
  'chat_queued_prompt_action': true,
  'chat_skill_library_action': true,
  'chat_turn_cancelled': true,
  'checkout.initiate.click': true,
  'checkout.redirect.block': true,
  'checkout.redirect.submit': true,
  'checkout.return.fail': true,
  'checkout.return.success': true,
  'checkout.return.unmatched': true,
  'composer_upload_menu_viewed': true,
  'copy_invite_link_succeeded': true,
  'create_invite_link_clicked': true,
  'create_team_clicked': true,
  'dashboard_project_opened': true,
  'director_skills_picker_action': true,
  'generated_output_viewed': true,
  'landing_page_project_setup_advanced_toggled': false,
  'landing_page_prompt_console_started': false,
  'landing_page_prompt_submitted': false,
  'landing_page_view': false,
  'landing_prompt_option_action': false,
  'landing_story_gallery_viewed': false,
  'landing_story_opened': false,
  'landing_story_preview_started': false,
  'node_generation_submitted': true,
  'node_panel_viewed': true,
  'nux_tooltip_dismissed': true,
  'nux_tooltip_shown': true,
  'project_create_clicked': true,
  'project_editor_viewed': true,
  'project_header_control_clicked': true,
  'project_header_surface_viewed': true,
  'project_presence_updated': true,
  'project_prompt_submitted': true,
  'project_publish_result': true,
  'project_setting_changed': true,
  'project_view_mode_viewed': true,
  'published_project_clone_clicked': true,
  'rules_surface_viewed': true,
  'settings.token_catalog.view': true,
  'settings.usage_and_tokens.view': true,
  'settings_api_key_action': true,
  'settings_default_video_model_changed': true,
  'settings_director_model_changed': true,
  'settings_profile_changed': true,
  'settings_rules_action': true,
  'team_section_viewed': true,
  'teams_active_team_switched': true,
  'teams_invite_join_clicked': true,
  'teams_member_allowance_action': true,
  'teams_member_removed': true,
  'teams_member_role_changed': true,
  'teams_project_shared': true,
  'teams_team_deleted': true,
  'teams_team_left': true,
  'templates_template_clicked': false,
  'token_catalog.option.click': true,
}

/** Events declared in the schema but intentionally without a caller yet. */
export const RESERVED_CLIENT_ANALYTICS_EVENTS: readonly ClientAnalyticsEventName[] = [
  'admin_onboarding_reconcile_opened',
  'admin_onboarding_resume_clicked',
  'byom_viewed',
  'canvas_project_exported',
  'canvas_video_download_initiated',
  'generated_output_viewed',
  'landing_story_gallery_viewed',
  'node_panel_viewed',
  'project_header_surface_viewed',
  'project_presence_updated',
  'project_view_mode_viewed',
  'rules_surface_viewed',
  'team_section_viewed',
]
